<script>
  import { Tooltip } from '@sveltestrap/sveltestrap';
  import { v4 as uuidv4 } from 'uuid';

  import { Icon } from '@client/components/icon';

  export let error = undefined;

  const id = `row-status-${uuidv4()}`;
</script>

{#if error}
  <Icon {id} name="alert-triangle" class="text-danger" />
  <Tooltip target={id}>
    {error}
  </Tooltip>
{:else}
  <Icon name="check-circle" class="text-success" />
{/if}
